module.exports = __webpack_public_path__ + "static/media/motor2.21bc48a3.jpg";